<template>
  <div class="container">
    <template v-for="(content, i) of contents">
      <Block
        v-if="content.type === 'text'"
        :key="`content-${i}`"
        :title="content.value.title || null"
      >
        <div v-html="content.value.text" />
      </Block>
      <DataExplorer
        v-else-if="content.type === 'explorer'"
        :key="`content-${i}`"
        :parameters="content.value(apiRoute).parameters || []"
        :computedParameters="content.value(apiRoute).computedParameters || []"
        :defaultParameterValues="content.value(apiRoute).parameterValues || {}"
        :indicators="content.value(apiRoute).indicators || []"
        :notes="content.value(apiRoute).notes || null"
      />
    </template>
  </div>
</template>

<script>
import { DataExplorer } from "@international-energy-agency/vue-ui/highcharts";
import { Block } from "@international-energy-agency/vue-ui";

export default {
  name: "TabContent",
  components: {
    DataExplorer,
    Block,
  },
  props: {
    // Used for v-model binding
    value: {
      required: false,
      default: null,
    },
    tab: {
      type: String,
      required: true,
    },
    contents: {
      type: Array,
      required: true,
    },
    apiRoute: {
      type: String,
      reauired: true,
    },
  },
  mounted() {
    this.country = this.value;
  },
  computed: {
    parameterValues() {
      const explorer = this.contents.find((c) => c.type === "explorer");
      if (!explorer) {
        return null;
      }
      return explorer.value(this.apiRoute).parameterValues;
    },
    country: {
      get() {
        return this.parameterValues.COUNTRY;
      },
      set(newValue) {
        this.parameterValues.COUNTRY = newValue;
      },
    },
  },
  watch: {
    value(newValue) {
      if (newValue !== this.country) {
        this.country = newValue;
      }
    },
    country(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit("input", newValue);
      }
    },
  },
};
</script>
<style>
.indicator-box .m-chart-metadata__copyright {
  width: 100% !important;
}
</style>